import React from 'react'
import { MenuItem } from '@mui/material'
import MuiSelectWrapper from 'gui/components/common/MuiSelect'
import INPUT_FORMAT_OPTIONS from './options'
import './index.scss'

export default function TextInputFormatSelect (props) {
  const {
    id,
    value,
    defaultValue,
    disabled,
    label = 'Input Format',
    name = 'textInputFormat',
    className,
    onChange,
  } = props
  return (
    <MuiSelectWrapper
      id={id}
      name={name}
      className={className}
      label={label}
      onChange={onChange}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
    >
      {INPUT_FORMAT_OPTIONS.map((option) => (
        <MenuItem value={option.get('value')} key={`text-input-format-${option.get('value')}`}>
          {option.get('label')}
        </MenuItem>
      ))}
    </MuiSelectWrapper>
  )
}
